import { render, staticRenderFns } from "./ReleasesNavBar.vue?vue&type=template&id=8e5ff67a&scoped=true"
import script from "./ReleasesNavBar.vue?vue&type=script&lang=js"
export * from "./ReleasesNavBar.vue?vue&type=script&lang=js"
import style0 from "./ReleasesNavBar.vue?vue&type=style&index=0&id=8e5ff67a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5ff67a",
  null
  
)

export default component.exports